import {
  DispatchTripRead,
  RunBambiRunReassignedTripRead,
  RunBambiRunTripRead,
  TripRead,
} from 'src/common/external/bambi-api/bambiApi';

export function getTripDropoffAddress(
  trip:
    | DispatchTripRead
    | RunBambiRunTripRead
    | RunBambiRunReassignedTripRead
    | TripRead
): string {
  if ('dropoff_address' in trip) {
    return trip.dropoff_address;
  }

  if (!('dropoff' in trip)) {
    throw new Error('Got an unexpected trip type');
  }

  return trip.dropoff.address;
}
